import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import HeadingArea from '../../general/HeadingArea';
import { FaFileImage, FaFilePdf } from 'react-icons/fa';

const ReportHomework = ({setLoading}) => {
    const location = useLocation();
  const { item } = location.state || {};
  const navigate = useNavigate();
  const [submission, setSubmission] = useState([]);

    const fetchSub = async () => {
    setLoading(true);
    try {
      const res = await fetch(`https://api.kcian.in/get-hw-report/${item.id}`);
      if (res.ok) {
        const data = await res.json();
        console.log(data);
        setSubmission(data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
fetchSub();

  }, [])

      const formatDate = (dateString) => {
        const date = new Date(dateString);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");

        return `${day}-${month}-${year} `;
    };


  return (
    <>
<section className='px-4'>
<div className='py-4'>

        <HeadingArea message1="Homework" message2="Report" />

<button className='profile-btn2' onClick={() => navigate('/admin/homework-list')}>Go Back</button>

<div className='table-responsive my-4 bg-white rounded-top-4'>
<table className='w-100'>

<thead className='account-thead'>
    <th className='rounded-start-4'>Description</th>
                    <th>Marks</th>
                    <th>Attachment</th>
                    <th>Homework Date</th>
    <th className='rounded-end-4'>Submission Date</th>
</thead>

<tr className='account-tr'>
                          <td>{item.description}</td>
                          <td>{item.marks || '--'}</td>
                                                                      <td>
                                                {item.file ? (() => {
                                                    // Extract file extension
                                                    const ext = item.file.split('.').pop().toLowerCase();

                                                    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

                                                    const handleClick = () => {
                                                        window.open(`https://api.kcian.in/inUploads/${item.file}`, '_blank');
                                                    };

                                                    if (ext === 'pdf') {
                                                        return <FaFilePdf style={{ cursor: 'pointer', color: 'red' }} size={21} onClick={handleClick} title="View Document" />;
                                                    } else if (imageExts.includes(ext)) {
                                                        return <FaFileImage style={{ cursor: 'pointer', color: 'purple' }} size={21} onClick={handleClick} title="View Image" />;
                                                    } else {
                                                        return '--';
                                                    }
                                                })() : '--'}
                                            </td> 
                          <td>{formatDate(item.homework_date)}</td>
                          <td>{formatDate(item.submission_date)}</td>
                      </tr>

</table>
</div>


<p className='profile-heading'>Submissions</p>

<div className='table-responsive my-4 bg-white rounded-top-4'>
<table className='w-100'>

<thead className='account-thead'>
    <th className='rounded-start-4'>Roll No</th>
                    <th>Student Name</th>
                    <th>Reg No</th>
                    <th>Attachment</th>
    <th className='rounded-end-4'>Submitted On</th>
</thead>


                  {submission.length > 0 ? (
                    submission.map((item, index) => {

                      return (
                        <tr key={item.id} className="account-tr">
                          <td>{item.student_roll}</td>
                          <td>{item.student_name}</td>
                          <td>{item.student_reg || '--'}</td>
                                                                      <td>
                                                {item.attach ? (() => {
                                                    // Extract attach extension
                                                    const ext = item.attach.split('.').pop().toLowerCase();

                                                    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

                                                    const handleClick = () => {
                                                        window.open(`https://api.kcian.in/inUploads/${item.attach}`, '_blank');
                                                    };

                                                    if (ext === 'pdf') {
                                                        return <FaFilePdf style={{ cursor: 'pointer', color: 'red' }} size={21} onClick={handleClick} title="View Document" />;
                                                    } else if (imageExts.includes(ext)) {
                                                        return <FaFileImage style={{ cursor: 'pointer', color: 'purple' }} size={21} onClick={handleClick} title="View Image" />;
                                                    } else {
                                                        return '--';
                                                    }
                                                })() : '--'}
                                            </td> 
                          <td>{formatDate(item.submitted_on)}</td>
 </tr>
                      );
                    })
                  ) : (
                    <tr className="account-tr text-center">
                      <td colSpan="7">No records found.</td>
                    </tr>
                  )}


</table>
</div>

</div>
    </section>

    </>
  )
}

export default ReportHomework
